<template>
  <div>
    <PesquisaPacienteModal
        v-if="modalSelecionarPaciente"
        v-model="modalSelecionarPaciente"
        @fecharModalPesquisaPaciente="fecharModalSelecionarPaciente"
        @confirmarPacienteSelecionado="selecionarPaciente"
    />
    <v-dialog v-model="model" max-width="720" scrollable persistent>
      <v-card>
        <v-toolbar dark color="primary" elevation="0">
          <v-toolbar-title>
            Gerar relatório de cobranças
          </v-toolbar-title>
          <v-spacer/>
          <v-btn class="close__button" text @click="fecharModal" icon>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pt-5">
          <div v-if="pacienteSelecionado.id && permitirSelecionarPaciente" class="container-card-paciente tertiary">
            <div class="container-acessar-ficha">
              <div>
                <span style="font-size: 14px">Nome</span><br/>
                <p class="d-inline-block text-truncate max-text">{{ pacienteSelecionado.nome }}</p>
              </div>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" @click="acessarFichaPaciente" icon>
                    <v-icon size="50">mdi-account-box</v-icon>
                  </v-btn>
                </template>
                Acessar ficha do paciente
              </v-tooltip>
            </div>
            <span style="font-size: 14px">CPF/CNPJ</span>
            <p>{{ pacienteSelecionado.cnpjCpf | formatarCpfCnpj }}</p>
          </div>
          <div class="container-selecionar-paciente" v-if="permitirSelecionarPaciente">
            <botao-acao hideBorder @click="removerPaciente" class="mr-4" v-if="pacienteSelecionado.id">
              <v-icon>close</v-icon>
              Remover Paciente
            </botao-acao>
            <botao-acao hideBorder @click="abrirModalSelecionarPaciente">
              <v-icon>mdi-magnify</v-icon>
              Selecionar Paciente
            </botao-acao>
          </div>
          <v-row wrap align-center white class="pl-5 pr-5">
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-select
                  v-model="filtros.statusCobranca"
                  label="Selecionar o status"
                  :items="statusItems"
                  item-text="nome"
                  item-value="valor"
              />
            </v-col>
            <v-col cols="4" md="4" sm="12" xs="12">
              <v-select
                  v-model="filtros.tipoPeriodo"
                  label="Selecionar tipo período"
                  :items="periodoItens"
                  item-text="nome"
                  item-value="valor"
              />
            </v-col>
            <v-col cols="4" md="4" sm="12" xs="12">
              <date-input
                  v-model="filtros.dataInicio"
                  label="Data Início"
                  name-date="dataInicio"
                  placeholderDate="Informe a data de início"
              />
            </v-col>
            <v-col cols="4" md="4" sm="12" xs="12">
              <date-input
                  v-model="filtros.dataFim"
                  label="Data Fim"
                  name-date="dataFim"
                  placeholderDate="Informe a data final"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-container>
          <v-row wrap align-center white class="pl-10 pr-10 row-bottom">
            <botao-cancelar @cancelar="fecharModal"/>
            <div style="display: flex; flex-direction: row">
              <v-tooltip top>
                <template v-slot:activator={on}>
                  <v-btn v-on="on" color="primary" fab small depressed @click="tratarEventoGerarRelatorio(true)"
                         class="mr-5">
                    <v-icon>mdi-file-download</v-icon>
                  </v-btn>
                </template>
                Baixar .PDF
              </v-tooltip>
              <botao-salvar @salvar="tratarEventoGerarRelatorio(false)" texto="Imprimir"/>
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import {actionTypes} from '@/core/constants'
import BotaoSalvar from '@/views/components/BotaoSalvar.vue'
import BotaoCancelar from '@/views/components/BotaoCancelar.vue'
import DateInput from '@/views/components/DateInput.vue'
import PesquisaPacienteModal from '@/views/modais/PesquisaPacienteModal.vue'
import BotaoAcao from '@/views/components/BotaoAcao.vue'

export default {
    name: 'GerarRelatorioCobrancas',
    components: {BotaoAcao, PesquisaPacienteModal, DateInput, BotaoCancelar, BotaoSalvar},
    props: {
        value: {
            type: Boolean,
            required: true
        },
        pacientePreSelecionado: Object,
        permitirSelecionarPaciente: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            modalSelecionarPaciente: false,
            pacienteSelecionado: {
                id: null,
                nome: null,
                cnpjCpf: null
            },
            filtros: {
                dataInicio: null,
                dataFim: null,
                tipoPeriodo: 'DATA_CRIACAO',
                statusCobranca: 'TODOS',
            },
            periodoItens: [
                {nome: 'Data criação', valor: 'DATA_CRIACAO'},
                {nome: 'Data pagamento', valor: 'DATA_PAGAMENTO'},
                {nome: 'Data estorno', valor: 'DATA_ESTORNO'},
            ],
            statusItems: [
                {nome: 'Todos os status', valor: 'TODOS'},
                {nome: 'Pagamento pendente', valor: 'PENDENTE'},
                {nome: 'Parcialmente paga', valor: 'PARCIALMENTE_PAGO'},
                {nome: 'Pago', valor: 'PAGO'},
                {nome: 'Cancelada', valor: 'CANCELADA'},
            ]
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    mounted() {
        this.setarPacientePreSelecionado()
    },
    methods: {
        setarPacientePreSelecionado() {
            if (this.pacientePreSelecionado) {
                this.pacienteSelecionado = this.pacientePreSelecionado
            }
        },
        abrirModalSelecionarPaciente() {
            this.modalSelecionarPaciente = true
        },
        fecharModalSelecionarPaciente() {
            this.modalSelecionarPaciente = false
        },
        selecionarPaciente(paciente) {
            this.fecharModalSelecionarPaciente()
            this.pacienteSelecionado = paciente
        },
        removerPaciente() {
            this.pacienteSelecionado = {
                id: null,
                nome: null,
                cnpjCpf: null
            }
        },
        acessarFichaPaciente() {
            this.$router.push({name: 'PacienteFicha', params: {id: this.pacienteSelecionado.id}})
        },
        async tratarEventoGerarRelatorio(baixar) {
            let filtros = {
                dataInicio: this.filtros.dataInicio,
                dataFim: this.filtros.dataFim,
                tipoPeriodo: this.filtros.tipoPeriodo,
                statusCobranca: this.filtros.statusCobranca,
                pacienteId: this.pacienteSelecionado.id,
                baixar: baixar
            }
            await this.$store.dispatch(actionTypes.RELATORIOS.GERAR_RELATORIO_COBRANCA, filtros)
        },
        fecharModal() {
            this.model = false
            this.$emit('fecharModalRelatorio')
        }
    }
}
</script>

<style scoped lang="stylus">

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding-top 10px
  padding-bottom 10px
  display flex
  justify-content space-between

.container-card-paciente
  border-radius 5px
  padding 5px
  margin-bottom 10px

  p
    font-weight bold
    color #5A5A5A

.container-acessar-ficha
  display flex
  justify-content space-between

.container-selecionar-paciente
  text-align right
  margin-bottom 10px

.max-text
  max-width 15vw

</style>